import { render } from "./tenant.vue?vue&type=template&id=e6fb33e6&scoped=true"
import script from "./tenant.js?vue&type=script&lang=js"
export * from "./tenant.js?vue&type=script&lang=js"

import "./tenant.vue?vue&type=style&index=0&id=e6fb33e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6fb33e6"]])

export default __exports__